var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors } from 'syf-component-library/defaultTheme';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { Trans } from 'react-i18next';
import { Body } from 'syf-component-library/ui/typography';
import Icon from '../../../../icon';
import { FAR_ARROW_UP_RIGHT, FAS_CIRCLE_ONE, FAS_CIRCLE_TWO } from '../../../../../const/icon-props';
import { SamsClubLink, Step, StepsContainer } from './subcomponents';
import { translate } from '../../../strings/i18n';
var SamsSteps = function (_a) {
    var title = _a.title;
    var SamsClubLinkText = translate('steps.one');
    var samsLink = (_jsx(SamsClubLink, __assign({ icon: _jsx(Icon, { title: "arrow up right icon", color: colors.cyanBlue, icon: FAR_ARROW_UP_RIGHT, size: "1x" }) }, { children: SamsClubLinkText })));
    return (_jsx(Inset, __assign({ top: "xlarge", vertical: "xxlarge", hideOnBreakpointDown: "small" }, { children: _jsx(Inset, __assign({ horizontal: "medium", hideOnBreakpointUp: "small" }, { children: _jsxs(StepsContainer, __assign({ all: "large" }, { children: [_jsx(Body, { children: title }), _jsx(Stack, {}), _jsxs(Step, __assign({ className: "circle-icon" }, { children: [_jsx(Body, { children: _jsx(Icon, { title: "check circle one icon", color: colors.success, icon: FAS_CIRCLE_ONE, size: "1x" }) }), _jsx(Body, { children: _jsx(Trans, __assign({ i18nKey: "samsClubLink", value: samsLink, components: { samsLink: samsLink } }, { children: translate('steps.one', { SamsClubLinkText: SamsClubLinkText }) })) })] })), _jsx(Stack, { size: "medium" }), _jsxs(Step, { children: [_jsx(Body, { children: _jsx(Icon, { title: "check circle two icon", color: colors.success, icon: FAS_CIRCLE_TWO, size: "1x" }) }), _jsx(Body, { children: translate('steps.two') })] })] })) })) })));
};
export default SamsSteps;
